module.exports = __webpack_public_path__ + "c7be3abf96feefbca4c71bfa6eae43c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000OQW.png
// module id = 1616
// module chunks = 0